import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assests/logo.png';
import './Navbar.css';

export default function Navbar() {
  return (
    <div className="px-5 login__navbar">
      <div className="navbar__container">
        <div className="navbar__left">
          <Link to="/" className="navbar__logo">
            <img src={logo} alt="logo" />
          </Link>
        </div>
        <div className="navbar__right">
          <Link to="/login" className="navbar__link">
            Get Started
          </Link>
        </div>
      </div>
    </div>
  );
}
